<template>
  <div id="period">
    <h1>Math</h1>
    <p>Today we are going to...</p>
    <hr class="uk-divider-icon">
    <ol class="lessons">
       <li v-for="work in getMathClasswork" :key="work.id">
          <h3><a :href="work.alternateLink" target="_blank">{{ work.title }}</a></h3>
          <p>{{ work.description }}</p>
          <!-- <div v-if="work.materials">
            <h4>Lesson Materials</h4>
            <ul>
              <li v-for="(material, index) in work.materials" :key="index">
                <div v-if="material.driveFile">
                  <div v-for="file in material.driveFile" :key="file.id">
                    <a :href="file.alternateLink" target="_blank" class="uk-button uk-button-medium">{{ file.title }}</a>
                  </div>
                </div>
                <div v-if="material.form">
                  <a :href="material.form.formUrl" target="_blank" class="uk-button uk-button-medium">{{ material.form.title }}</a>
                </div>
              </li>
            </ul>
          </div> -->
          <a :href="work.alternateLink" target="_blank" class="uk-button uk-button-primary uk-button-medium">View Assignment</a>
          <hr class="uk-divider-icon">
      </li>
    </ol>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
// https://auth0.com/blog/vuejs2-authentication-tutorial/
export default {
  name: "MathVue",
  components: {
  },
  created() {
    console.log('call retrieve math classwork action');
    this.retrieveMathClassworkAction();
  },
  methods: {
    ...mapActions(["retrieveMathClassworkAction"]),
  },
   computed: {
    ...mapGetters(["getUser", "getMathClasswork"])
  }
};
</script>